import { styled } from '@mui/material';

export const HelperWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
